import Vue from 'vue';
import Router from 'vue-router';
import { routes } from '@/router/routes';
import { container } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
var authService = container.get(TYPES.AuthService);
var router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes,
});
router.beforeEach(function (to, from, next) {
    // Fix local storage issue with IE by forcing browser to re-lookup storage
    // https://stackoverflow.com/a/42377129
    window.onstorage = function (e) {
        // purposefully empty, as per comment above
    };
    // no auth required as callback page and health check
    if (to.path === '/authenticated' || to.path === '/hc' || to.path === '/forbidden') {
        return next();
    }
    // logout, redirects to login page if not authenticated
    if (!authService.isAuthenticated()) {
        return authService.login();
    }
    // if the timeout doesn't exist yet, set it (ex. when the user first logs in)
    // tslint:disable-next-line:no-string-literal
    if (!window['tokenRenewalTimeout']) {
        authService.renewSession();
    }
    // special pages that need no auth checks
    if (to.path === '/') {
        document.title = 'Fuel Shepherd';
        return next();
    }
    // if redirected and original route had authorize metadata
    if (to.name && to.name.toLowerCase() === 'legacy') {
        var originalTo = routes.filter(function (route) { return route.path === "/Shepherd2/" + to.params.page; })[0];
        // if user is authenticated for original route before redirect
        // tslint:disable-next-line:max-line-length
        if (originalTo && originalTo.meta && originalTo.meta.authorize && authService.isAuthorized(originalTo.meta.authorize)) {
            document.title = "Fuel Shepherd - " + originalTo.name;
            return next();
        }
        else {
            document.title = "Fuel Shepherd - " + to.params.page;
            return next(to.params.page);
        }
    }
    // if authorize metadata is set and user is authenticated, then continue to page
    if (to.meta && to.meta.authorize && authService.isAuthorized(to.meta.authorize)) {
        document.title = to.params && to.params.id
            ? "Fuel Shepherd - " + to.name + " - " + to.params.id
            : "Fuel Shepherd - " + to.name;
        return next();
    }
    else {
        // redirect to dashboard
        return next('/');
    }
    // if no matches then carry on, return 404 page
    next();
});
Vue.use(Router);
export default router;
